module.exports = __webpack_public_path__ + "static/media/4.451b1e4b.jpg";